export enum E_QueryLogic {
    AND = 'AND',
    OR = 'OR'
}
export enum E_QueryType {
    BOOL = 'BOOL',
    KEYWORD = 'KEYWORD',
    FIELD = 'FIELD',
    RANGE = 'RANGE'
}

export enum E_QueryField {
    TEXT = 'TEXT',
    KEYWORD = 'KEYWORD',
    /**
     * MATERIAL 相关
     */
    VF_SPUM = 'VF_SPUM',
    VF_MATERIAL_CLASSIFICATION = 'VF_MATERIAL_CLASSIFICATION',
    PUM_PROP_ID = 'PUM_PROP_ID',
    PUM_UNIT = 'PUM_UNIT',
    SUBSTANCE_ALL = 'SUBSTANCE_ALL',
    SUBSTANCE_ONLY = 'SUBSTANCE_ONLY',
    SUBSTANCE_IDS = 'SUBSTANCE_IDS',
    /**
     * 配方池字段
     */
    VF_SFP= 'VF_SFP',
    VF_MUST = 'VF_MUST',
    VF_ANY = 'VF_ANY',
    VF_NOT = 'VF_NOT',
    /**
     * 结构式字段
     */
    VF_SUBSTANCE_EXT = 'VF_SUBSTANCE_EXT',
    VF_SUBSTANCE_SIM = 'VF_SUBSTANCE_SIM',
    VF_SUBSTANCE_SUB = 'VF_SUBSTANCE_SUB',
    VF_SUBSTANCE_SUP = 'VF_SUBSTANCE_SUP',
    VF_SUBSTANCE_STRUCTURE = 'VF_SUBSTANCE_STRUCTURE'
}

// 前端query结构和UI对应，必须为IQueryRoot包含IQueryBlock，IQueryBlock包含IQueryItem
// 但服务端的query只输入关键词的情况其实没有block这层，需要转换
// 所有前端的query结构都可以转成服务端query，反之不行。比如多层括号嵌套，UI最多展示2层
export interface IQueryItem {
    logic: E_QueryLogic,
    type?: E_QueryType,
    value?: unknown,
    name?: string,
    field?: string,
    items?: IQueryItem[],
    // 后端用的是value来查，但是高级搜索用label作为value，额外提供一个id用于后期回显
    id?: string,
}

export interface IFieldQueryItem extends IQueryItem {
    value: IQueryItem[],
}

export interface IClassificationQueryItem extends IQueryItem {
    // 用于分类号还原语言
    name_cn: string,
    name_en: string,
}

export interface IBoolQueryItem extends IQueryItem {
    value: IQueryItem[],
}

export interface IKeywordQueryItem extends IQueryItem {
    value: string,
}

export interface IRangeQueryItem extends IQueryItem {
    from: string,
    to: string,
}

export type IQueryBlock = {
    logic: E_QueryLogic,
    type: E_QueryType,
    items?: IQueryItem[],
    field?: string,
    value?: any,
    name?: string,
    id?: string,
}

export type IQueryBlockWithoutLogic = Omit<IQueryBlock, 'logic'>;

export interface IQueryRoot {
    logic: E_QueryLogic.AND,
    type: E_QueryType.BOOL,
    items: IQueryBlock[]
}

//
export interface IPumItem extends IQueryItem {
    name: string,
    value: string,
    u?: string,
    m?: [string, string],
}
